<template>
  <div class="mian_view">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="main">
      <h2>统计分析</h2>
      <div class="info_view">
        <p class="info_t">基本信息</p>
        <ul>
          <li>
            <p>任务名称</p>
            <p>任务状态</p>
            <p>课程生效日期</p>
            <p>备注</p>
          </li>
          <li>
            <p>三月三基学习任务</p>
            <p :class="stateColour(1)">进行中</p>
            <p>2021-01-20</p>
            <p>--</p>
          </li>
          <li>
            <p>视频数量</p>
            <p>任务创建日期</p>
            <p>课程结束日期</p>
            <p></p>
          </li>
          <li>
            <p>3</p>
            <p>2021-01-20</p>
            <p>2021-01-20</p>
            <p></p>
          </li>
        </ul>
        <div class="course_info">
          <p class="info_t">课程信息</p>
          <div class="course_view">
            <div class="course_item">
              <div class="course_left">
                <p>应学习人数</p>
                <p>325 <span>人</span></p>
              </div>
              <div class="course_right">
                <p>
                  <span>已开始</span>
                  300人
                </p>
                <p>
                  <span>未开始</span>
                  20人
                </p>
              </div>
            </div>
            <div class="course_item">
              <div class="course_left">
                <p>总学习人数</p>
                <p>7246 <span>人</span></p>
              </div>
              <div class="course_right">
                <p>
                  <span>已开始</span>
                  300人
                </p>
                <p>
                  <span>未开始</span>
                  20人
                </p>
              </div>
            </div>
            <div class="course_item"></div>
            <div class="course_item"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import taskApi from "@/api/videoTask";

export default {
  data() {
    return {};
  },
  props: ["cutcoms"],
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.cutcoms(0);
    },
    // 获取任务信息
    async getTaskInfo() {
      const obj = {
        taskID: this.$parent.rowObj.taskId,
      };
      const { data } = await taskApi.taskStat(obj);
      console.log(data);
    },
  },
  activated() {
    this.getTaskInfo();
  },
  computed: {
    stateColour() {
      return function (row) {
        // 考场关闭且有人在考场禁用
        if (row) {
          return "yellow";
        } else if (row) {
          return "red";
        } else {
          return "green";
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.mian_view {
  // height: 100%;
  width: 100%;
  min-height: 780px;
  padding-bottom: 46px;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.main {
  padding: 24px;
  .info_view {
    margin-top: 36px;
    > .info_t {
      font-size: 24px;
    }
    ul {
      display: flex;
      list-style-type: none;
      margin-top: 24px;
      > li {
        border: 1px solid #000;
        height: 240px;
        flex: 1;
        p {
          padding: 16px;
        }
      }
    }
    .course_info {
      margin-top: 36px;
      > .info_t {
        font-size: 24px;
      }
      .course_view {
        display: flex;
        align-items: center;
        margin-top: 24px;
        .course_item {
          display: flex;
          > div {
            height: 100%;
            text-align: center;
            padding: 50px 0px;
            border: 1px solid #000;
            flex: 1;
          }
          .course_left {
            > p {
              &:nth-child(1) {
                margin-bottom: 20px;
              }
              &:nth-child(2) {
                font-size: 32px;
                margin-top: 20px;
              }
            }
          }
          .course_right{
            >p{
                >span{
                    text-align: left;
                    border: 1px solid #000;
                }
            }
          }
        }
        > div {
          flex: 1;
          height: 200px;
          box-shadow: 0px 1px 6px #e7e7e7;
          margin-right: 24px;
          &:nth-child(4) {
            box-shadow: none !important;
          }
        }
      }
    }
  }
}
.green {
  color: #00d254 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #00d254;
  }
}
.red {
  color: #ff0000 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ff0000;
  }
}
.yellow {
  color: #ffa200 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ffa200;
  }
}
</style>